import { useEffect, useState } from 'react';

import {
    DigitalhubDivider,
    EchtDigitalLogo,
    Footer,
    SHStateChancelleryLogo,
    WTSHLogo
} from '@dh/components';
import { WrapContainer } from '@dh/styles';
import { useBreakpoint } from '@dh/hooks';
import { isExpanded } from '@dh/types';

import { DashboardFooterContainer, DashboardFooterLogoContainer } from './styles';

const LandingPageLoggedInFooterSection = () => {
    const [angle, setAngle] = useState(-12); // initialer Fallback-Winkel
    const breakpoint = useBreakpoint();
    const isExpandedLayout = isExpanded(breakpoint);

    useEffect(() => {
        const updateAngle = () => {
            const vw = window.innerWidth;
            const deltaX = vw * 0.66;
            const deltaY = -148; // von 148px nach 0px
            const radians = Math.atan(deltaY / deltaX);
            const degrees = radians * (180 / Math.PI);
            setAngle(degrees);
        };

        updateAngle();
        window.addEventListener('resize', updateAngle);
        return () => window.removeEventListener('resize', updateAngle);
    }, []);

    return (
        <DashboardFooterContainer>
            <DigitalhubDivider
                sx={{
                    position: isExpanded(breakpoint) ? 'absolute' : 'relative',
                    top: isExpanded(breakpoint) ? '142px' : '0',
                    left: isExpanded(breakpoint) ? 0 : '-5px',
                    width: '105vw',
                    height: '2px',
                    transform: isExpanded(breakpoint) ? `rotate(${angle}deg)` : 'rotate(-10deg)',
                    transformOrigin: isExpanded(breakpoint) ? 'top left' : 'left',
                    marginTop: isExpanded(breakpoint) ? 0 : '60px'
                }}
            />
            <DashboardFooterLogoContainer>
                <WrapContainer gap={4} mt={isExpandedLayout ? 6 : 0} justifyContent={'flex-end'}>
                    <EchtDigitalLogo />
                    <SHStateChancelleryLogo />
                    <WTSHLogo />
                </WrapContainer>
            </DashboardFooterLogoContainer>
            <Footer isLandingPage />
        </DashboardFooterContainer>
    );
};

export { LandingPageLoggedInFooterSection };
